import AddIcon from '@mui/icons-material/AddRounded';
import FloatingActionButton from '../../../_include/Buttons/FloatingActionButton';
import { useAppDispatch } from '../../../../store/hooks';
import { AddressReportActions } from '../../../../store/reducers/awareness_campaigns/address_report';
import { Box } from '@mui/material';

export default function AddAddressButton() {

    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(AddressReportActions.openReportForm(null));
    }

    return (
        <Box sx={{ pointerEvents: "auto" }}>
            <FloatingActionButton
                Icon={<AddIcon fontSize="large" />}
                color="success"
                iconColor="#ffffff"
                onClick={() => handleClick()}
            />
        </Box>
    );
}